module.exports = __webpack_public_path__ + "static/media/btn_download_google_play_store.5e9b3126.svg";